import Immutable from 'immutable';
import { createSelector } from 'reselect';

const allFeatures = state => state.getIn(['featureTogglz', 'features'], Immutable.List());
const featuresByName = state => state.getIn(['entities', 'features'], Immutable.Map());
const featureOverrides = state => state.getIn(['app', 'featureOverrides'], Immutable.Map());

export const selectFeatureStatuses = createSelector(
  allFeatures,
  featuresByName,
  featureOverrides,
  (featureNames, features, overrides) =>
    featureNames.reduce((result, featureName) => {
      const override = overrides.get(featureName);
      const featureStatus =
        override !== undefined ? override === 'true' : features.getIn([featureName, 'active'], false);
      return result.set(featureName, featureStatus);
    }, Immutable.Map())
);

export default {
  selectFeatureStatuses
};
